<div *ngIf="showModal" id="app-modal">
  <div class="app-modal-content">
    <app-modal
      modalOkButtonText="Close"
      modalCancelButtonText=""
      (dismissEvent)="showModal = false"
      (okEvent)="showModal = false"
      modalTitle="Security Message"
      modalBody="Logged out due to inactivity"
    ></app-modal>
  </div>
</div>
<div id="nav-top-wrapper" *ngIf="isAuthenticated">
  <app-navigation-top #navTop (sidebarToggled)="toggleSidebar($event)">
  </app-navigation-top>
</div>
<div
  id="main_page"
  *ngIf="!showModal"
  class="container-fluid"
  style="height: 100%"
>
  <div id="main_page_content" class="row">
    <div
      id="navigation"
      *ngIf="isAuthenticated"
      [ngClass]="{ 'd-none': !expandSideBar, 'height-100': isAuthenticated }"
      class="col-md-3 col-sm-12 d-sm-block"
    >
      <app-navigation-sidebar
        (navigationItemClicked)="hideNavBar()"
      ></app-navigation-sidebar>
    </div>
    <div
      [ngClass]="{ 'col-md-9': isAuthenticated }"
      class="content-wrapper col-sm-12"
      style="padding-bottom: 15px"
    >
      <div id="page" [ngClass]="{ authenticated: isAuthenticated }">
        <app-navigation-submenu></app-navigation-submenu>
        <div class="page-content row">
          <div class="col-12">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-navigation-footer *ngIf="!isAuthenticated"></app-navigation-footer>
</div>
